import { CLOSE_LOADER, OPEN_LOADER } from "../constants";

// export const closeLoader = () => ({ type: CLOSE_LOADER});
// export const openLoader = () => ({ type: OPEN_LOADER });


export const openLoader = (message: string, loaderType: string = "default") => ({ type: "OPEN_LOADER", payload: { message, loaderType }, });
export const closeLoader = () => ({ type: "CLOSE_LOADER",payload:{ message:'', loaderType:'default'} });
  